import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type ZoomOutIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

// No design-library glyph exists for zoom-out yet. Uses the Lucide 'zoom-out'
// glyph on its native 24x24 grid (stroke 1.5, round caps), matching
// FileTextIcon. Replace with the library asset when one lands.
export const ZoomOutIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: ZoomOutIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Zoom out'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='11'
        cy='11'
        r='8'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='m21 21-4.35-4.35'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M8 11h6'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
